import { render, staticRenderFns } from "./TourWindow.vue?vue&type=template&id=55128d96&scoped=true"
import script from "./TourWindow.vue?vue&type=script&lang=js"
export * from "./TourWindow.vue?vue&type=script&lang=js"
import style0 from "./TourWindow.vue?vue&type=style&index=0&id=55128d96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55128d96",
  null
  
)

export default component.exports